var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "lpu-doctors-schedule-specialty" },
    [
      _c(
        "button",
        {
          staticClass:
            "lpu-doctors-schedule-specialty__button d-flex align-center w-100",
          attrs: {
            type: "button",
            "data-qa": "lpu_doctors_schedule_specialty_btn",
            disabled: _vm.disabled || !_vm.specialities.length,
          },
          on: {
            click: function ($event) {
              _setup.isDrawerOpen = true
            },
          },
        },
        [
          _c(
            "span",
            {
              staticClass: "text-body-1 flex-grow-1 text-left text-truncate",
              class: _vm.selectedSpeciality
                ? "text--text"
                : "text-secondary--text",
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.selectedSpeciality?.name ||
                      _setup.tStatic("Специальность")
                  ) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c("span", {
            staticClass:
              "ui-icon-arrow-down text-secondary--text lpu-doctors-schedule-specialty__icon flex-shrink-0",
          }),
        ]
      ),
      _vm._v(" "),
      _c(_setup.CoreSelectionDrawer, {
        attrs: {
          "has-search": "",
          "is-checked-variant": "",
          value: _setup.isDrawerOpen,
          title: _setup.tStatic("Специальность"),
          placeholder: _setup.tStatic("Название специальности"),
          items: _vm.specialities,
          "selected-item": _vm.selectedSpeciality || undefined,
        },
        on: {
          input: function ($event) {
            _setup.isDrawerOpen = false
          },
          "click-item": _setup.handleSelect,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }